import { render } from "./CustomBookings.vue?vue&type=template&id=77ae6f28"
import script from "./CustomBookings.vue?vue&type=script&lang=js"
export * from "./CustomBookings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__